import styled from 'styled-components'

type IdentityLineProps = {
    color: string
}
export const FooterContainer = styled.div`
    height:auto;
    background-color:gray;
    //layout
    flex: 0 1 auto;
    @media print {
        background-color: transparent ;
    }
`

export const IdentityLine = styled.div<IdentityLineProps>`
    height:5px;
    background-color:${props=>props.color};
    @media print {
        background-color: transparent ;
    }
`

export const FooterContent = styled.div`
    /* margin-right:100px; */
    display: flex;
    justify-content:space-between;
    height:80px;
    color:#C4C4C4;
    margin: auto 150px;
    width: 100%;
    @media (max-width: ${props => props.theme.breakpoints.md}){ 
        flex-flow: wrap;
        height: auto;
        font-size: 12px;
        /* align-items: flex-start; */
        margin: auto 25px;
        /* justify-content: space-around; */
    }
    
`


export const ContactContainer = styled.div`
    height:170px;
    background-color:#444444;
    display:flex;
    align-items:center;
    justify-content:space-between;
    @media (max-width: ${props => props.theme.breakpoints.md}){ 
        height: auto;
    }
    @media print {
        background-color: transparent ;
    }
`

type EpaycoContainerProps = {
    bottom?: string
}

export const EpaycoContainer = styled.div<EpaycoContainerProps>`
    display:flex;
    height:70px;
    background-color:#222222;
    @media (max-width: ${props => props.theme.breakpoints.md}){ 
        margin-bottom: calc( 50px +  ${ props => props.bottom ?? '0px'})
    }
    @media print {
        background-color: transparent ;
    }
`
export const SignUp = styled.button`
    width:131px;
    border-radius: 4px;
    height:40px;
    padding: 0em 1em;
    background: #222222;
    color: #FFFFFF;
    outline: none;
    border:none;
    cursor: pointer;
    font-size: 16px;
    line-height: 19px;
    @media (max-width: ${props => props.theme.breakpoints.md}){ 
        width: 100%;
        margin-top: 1em;
    }
    @media print {
        background-color: transparent ;
    }

`

export const ContactElements = styled.div`
    /* margin-right:100px; */
    display: flex;
    /* justify-content:space-between; */
    flex-direction:column;
    height:100px;
    color:#C4C4C4;
    margin: 0;
    width: 100%;
    /* align-items: flex-end; */
    @media (max-width: ${props => props.theme.breakpoints.md}){ 
        font-size: 12px;
        align-items: flex-start;
        margin: auto 25px;
        justify-content: space-around;
    }
`

export const AccountContainer = styled.div`
    width: 100%;
    @media (max-width: ${props => props.theme.breakpoints.md}){ 
        margin-top: 1em;
    }
    @media print {
        display: none;
    }
`
export const AccountContent = styled.div`
    width: 100%;    
    display: flex;
    align-items: center;
    @media (max-width: ${props => props.theme.breakpoints.md}){ 
        margin: 1.5em 0em;
        flex-direction: column;
        align-items: flex-start;
        text-align: left;
    }
`
export const SignUpContainer = styled.div`
    width: 50%;    
    display: flex;
    justify-content: center;
    @media (max-width: ${props => props.theme.breakpoints.md}){ 
        width: 100%;    
    }
`

export const LegalContainer = styled.div`
    width:100%;
    display:flex;
    flex-direction: column;
    text-align:center;

    .blank-space {
        width: 46%; 
        display: flex; 
        text-align: left;
    }

    a {
        text-decoration: none;
        color: #ffffff;
    }

    @media (max-width: ${props => props.theme.breakpoints.md}){         
        width:20%;
        margin: 1.5em 0em;
        text-align: left;
        .blank-space {
            width: 0; 
        }
        
    }
    
    @media print {
        display: none;
    }

`
export const ContactShopContainer = styled.div`
    width:50%;
    display:flex;
    flex-direction: column;
    align-items: flex-start;
    
    .contacts-container{
      display:flex;
      flex-direction: column
    }
    
    .email-text{
        @media (max-width: ${props => props.theme.breakpoints.md}){  
            overflow-wrap: break-word;
            width: 50vw;
        }
      
    }
    
    .contact-info{
        display:flex;
        align-items: center;
        svg{
            margin-right: .5em;
        }
        
        @media print {
            align-items: flex-start;
            svg{
                display: none
            }
            color: black;
        }
    }
    
    .cellphoneWidth{
     width: 100%
    }

    @media (max-width: ${props => props.theme.breakpoints.md}){  
        width:70%;
        margin: 1.5em 0em;       
        align-items: flex-start;
        text-align: start;
    }

    @media print {
        margin: 0em;   
    }
`


export const ContactElement = styled.div`
    width:100%;
    display:flex;
    align-items:center;
  
`
export const ContactElementsRegister = styled.div`
    width:100%;
    display:flex;
    align-items:center;
  
`
export const ContactText = styled.p`
    margin: 0;
    color: #ffffff;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
`
export const ContactTextTitle = styled.p`
    margin: 0px 0px 15px 0px;
    font-weight: bolder;
    font-size: 17px;
    color: #ffffff;
`

export const EpaycoElements = styled.div`
    margin-left:150px;
    display:flex;
    align-items:center;
    img {
        width: 320px;
        height: 45px;
    }
    @media (max-width: ${props => props.theme.breakpoints.md}){ 
        margin: auto 25px;
    }
`

export const EpaycoLogo = styled.div`
    margin-left:5px;
    display:flex;
`




